import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, ButtonProps } from '@frontend/design-system';
import { trackingIds } from '../../tracking-ids';

interface FilterTrayToggleProps extends ButtonProps {
  isFilterActive?: boolean;
  noAutoMargin?: boolean;
}

export const FilterTrayToggle: FC<FilterTrayToggleProps> = ({ isFilterActive, noAutoMargin, ...props }) => {
  return (
    <span css={[styles.wrapper, !noAutoMargin && styles.autoMargin]}>
      <Button
        iconName='filter-alt'
        size='large'
        variant='secondary'
        aria-label='Filter'
        trackingId={trackingIds.filterTrayToggle}
        css={styles.button}
        {...props}
      />
      {isFilterActive && <span css={styles.dot} aria-hidden='true' />}
    </span>
  );
};

const styles = {
  wrapper: css`
    position: relative;
    display: inline-flex;
  `,
  autoMargin: css`
    margin-left: auto;
  `,
  button: css`
    position: relative;
    border: 1px solid ${theme.colors.neutral50};
    border-radius: ${theme.borderRadius.small};
  `,
  dot: css`
    position: absolute;
    top: 8px;
    right: 8px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${theme.colors.primary50};
    border: 2px solid ${theme.colors.white};
    pointer-events: none;
  `,
};
